// Every image the portal shows is imported here and nowhere else, so webpack fingerprints each file and
// portal.css can stay free of CSS image references (spec 3.10 and 8). Sizes are the real pixel sizes: each
// consumer sets width and height so nothing reflows while the image loads.
import logoWhite900 from "./assets/te-logo-white-900.png";
import logoWhite600 from "./assets/te-logo-white-600.png";
import logoRelationship900 from "./assets/te-logo-relationship-light-900.png";
import officeWide2400 from "./assets/office-sign-2400.jpg";
import officeWide1200 from "./assets/office-sign-1200.jpg";
import officeTall1080 from "./assets/office-sign-1080.jpg";

export const LOGO_WHITE_900 = { src: logoWhite900, width: 900, height: 299 };
export const LOGO_WHITE_600 = { src: logoWhite600, width: 600, height: 199 };
export const LOGO_RELATIONSHIP_900 = { src: logoRelationship900, width: 900, height: 302 };
export const OFFICE_WIDE = { width: 2400, height: 1350 };
export const OFFICE_WIDE_SMALL = { width: 1200, height: 675 };
export const OFFICE_TALL = { width: 1080, height: 1920 };
// The one switch (spec 8.2). Every user has its own fallback when this is null: the solo screens keep the
// approved gradient, Home shows no cover band unless the client has a photo, and the CRM picker's Office
// Photo tile is a navy square with the white logo.
export const officePhoto = { wide: officeWide2400, wideSmall: officeWide1200, tall: officeTall1080 };
